import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import KeyIssueEditItemDetails from "./KeyIssueEditItemDetails"
import KeyIssueEditRelatedInsightAreasContainer from "./KeyIssueEditRelatedInsightAreasContainer"
import KeyIssuePlaceholderImageEditWidgetContainer from "./KeyIssuePlaceholderImageEditWidgetContainer"
import KeyIssueConceptMappingsEditWidgetContainer from "./KeyIssueConceptMappingsEditWidgetContainer"
import KeyIssuePermissionHoldersEditWidgetContainer from "./KeyIssuePermissionHoldersEditWidgetContainer"

const KeyIssueEdit = ({
    model,
    onEventChange,
    onValueChange,
    onImageChange
}) => (
    <ItemDetailsColumns className="key-issue-item-container">
        <ItemDetailsColumn>
            <KeyIssueEditItemDetails
                name={model.name}
                subtitle={model.subtitle}
                status={model.status}
                description={model.description}
                imageUrl={model.image_url}
                imagePreviewURL={model.imagePreviewURL}
                onEventChange={onEventChange}
                onImageChange={onImageChange}
            />
            <div className="article-placeholders">
                <KeyIssuePlaceholderImageEditWidgetContainer
                    placeholders={model.placeholders}
                    isInheritEnabled={true}
                    isInheritingPlaceholders={model.inherit_placeholders}
                    onEventChange={onEventChange}
                />
            </div>
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <KeyIssueEditRelatedInsightAreasContainer
                primaryTopic={model.primary_topic}
                relatedTopics={model.topics}
                onValueChange={onValueChange}
            />
            <div id="keys-mappings">
                <KeyIssueConceptMappingsEditWidgetContainer
                    mappings={model.mappings}
                />
            </div>
            <div className="permission-holders">
                <KeyIssuePermissionHoldersEditWidgetContainer />
            </div>
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default KeyIssueEdit
